'use strict';

module.exports = require('./Autowhatever').default;


//////////////////
// WEBPACK FOOTER
// ./~/react-autowhatever/dist/index.js
// module id = 927
// module chunks = 0